import { render, staticRenderFns } from "./ContractFormModal.vue?vue&type=template&id=c1543be6&lang=pug&"
import script from "./ContractFormModal.vue?vue&type=script&lang=js&"
export * from "./ContractFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports